// src/App.js
import React from 'react';
import CookieConsent from './CookieConsent';
import './CookieConsent.css'

function CookieConsentApp() {
  return (
    <div className="App">
      <CookieConsent />
    </div>
  );
}


export default CookieConsentApp;